import { createSelector } from 'reselect';
import { statComparisonSelector } from './simple-selectors';

export const statComparisonDataSelector = createSelector(
    statComparisonSelector,
    (statComparison) => statComparison.data
);
